import React, { useEffect, useState } from "react";
import { Flex } from "../Flex";
import { Txt } from "../Txt";
import { useDebounce } from "shared/hook/useDebounce";
interface IViewChartDetailsRowProps {
  label: string;
  value: string | undefined;
}

export const ViewChartDetailsRow = ({
  label,
  value,
}: IViewChartDetailsRowProps) => {
  const [debouncedWidth, setDebouncedWidth] = useState<string>("0%");
  //ritardo nel set della width per garantire la transition
  useEffect(() => {
    if (!!value) {
      setTimeout(() => setDebouncedWidth(value), 500);
    }
    return () => setDebouncedWidth("0%");
  }, [value]);

  return (
    <Flex flexDirection="column" width={"100%"}>
      <Txt display="flex" fontWeight="bold" fontSize={"10px"}>
        {`${label} ${value ?? ""}`}
      </Txt>
      <Flex
        width={debouncedWidth ?? "0%"}
        backgroundColor="var(--primary)"
        height={"0.5em"}
        borderRadius={"0.1em"}
        transition="width 1s ease-in-out"
      />
    </Flex>
  );
};
